Vue.component('request-password-reset', {
    data () {
        return {
            resetPasswordForm: $.extend(true, new Form({
                data: {
                    email: ''
                }
            }), {})
        };
    },

    methods: {
        submit () {
            Http.post('/api/authpassword/request', this.resetPasswordForm).then(() => {
                this.resetPasswordForm.resetForm();
            });
        },
    }
});